import { DateField, FieldSelectedSections } from "@mui/x-date-pickers";
import { SxProps, Theme } from "@mui/material";
import { useCallback, useState } from "react";

import dayjs from "dayjs";

/**
 * DefaultTableDatePickerInput
 */

type Props = {
  value?: Date | null,
  helperText?: string,
  required?: boolean,
  readOnly?: boolean,
  disabled?: boolean,
  sx?: SxProps<Theme>,
  onChange?: (newValue: Date | null) => void,
};

export const DefaultTableDatePickerInput = ({
  value,
  helperText,
  required,
  readOnly,
  disabled,
  sx,
  onChange,
}: Props) => {
  const [selectedSection, setSelectedSection] =
    useState<FieldSelectedSections>("day");

  const handleOnChange = useCallback((dt: dayjs.Dayjs | null) => {
    if (dt === null || dt.isValid()) onChange?.(dt?.toDate() ?? null);
  }, [
    onChange,
  ]);

  const handleKeyDownCapture = useCallback((e: any) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    if (typeof selectedSection === 'number') {
      const normalizedIndex = selectedSection === -1 ? 0 : selectedSection;

      const nextIndex =
        e.key === "ArrowRight"
          ? Math.min(normalizedIndex + 1, 2)
          : Math.max(normalizedIndex - 1, 0);

      setSelectedSection(nextIndex);
    }
  }, [
    selectedSection,
  ]);

  return (
    <DateField
      sx={sx}
      size='small'
      fullWidth={true}
      required={required}
      error={helperText !== null && helperText !== undefined}
      helperText={helperText}
      disabled={disabled}
      readOnly={readOnly}
      value={value ? dayjs(value as any) : null}
      selectedSections={selectedSection}
      onSelectedSectionsChange={setSelectedSection}
      onKeyDownCapture={handleKeyDownCapture}
      onChange={handleOnChange}
    />
  );
}